import PropTypes from 'prop-types';
import React from 'react';
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/themes/light.css';
import 'tippy.js/dist/svg-arrow.css';
import './Tooltip.scss';

const RoundArrow = '<svg width="16" height="6" xmlns="http://www.w3.org/2000/svg"><path d="M0 6s1.796-.013 4.67-3.615C5.851.9 6.93.006 8 0c1.07-.006 2.148.887 3.343 2.385C14.233 6.005 16 6 16 6H0z"/></svg>';
/*
  adding some accessibility functionality for screen readers
*/

export const ContentAnnounced = ({
  as: Component = 'span',
  children,
}) => (
  <Component role="tooltip" aria-live="polite">
    {children}
  </Component>
);

const ariaOptions = {
  content: 'describedby',
  expanded: false,
};

/*
  Note that children should be a focusable element
*/
const Tooltip = ({
  arrow,
  children,
  content,
  hideOnClick,
  onClickOutside,
  maxWidth,
  offset,
  showOnCreate,
  theme,
  trigger,
  visible,
  animation,
  zIndex,
}) => (
  <Tippy
    arrow={arrow === 'round' ? RoundArrow : arrow}
    content={<ContentAnnounced>{content}</ContentAnnounced>}
    duration={[500, 100]}
    hideOnClick={hideOnClick}
    maxWidth={maxWidth}
    offset={offset}
    placement="bottom-end"
    showOnCreate={showOnCreate}
    theme={theme}
    trigger={trigger}
    visible={visible}
    zIndex={zIndex}
    aria={ariaOptions}
    appendTo={() => document.body}
    onClickOutside={onClickOutside}
    animation={animation}
  >
    {children}
  </Tippy>
);

ContentAnnounced.propTypes = {
  as: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf([
      PropTypes.element,
    ]),
  ]).isRequired,
};

ContentAnnounced.defaultProps = {
  as: 'span',
};

Tooltip.propTypes = {
  arrow: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf([
      PropTypes.element,
    ]),
  ]).isRequired,
  content: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.string,
  ]).isRequired,
  hideOnClick: PropTypes.bool,
  onClickOutside: PropTypes.func,
  maxWidth: PropTypes.string.isRequired,
  offset: PropTypes.arrayOf([
    PropTypes.number,
  ]).isRequired,
  showOnCreate: PropTypes.bool,
  theme: PropTypes.string.isRequired,
  trigger: PropTypes.string,
  visible: PropTypes.bool,
  animation: PropTypes.bool,
  zIndex: PropTypes.number,
};

Tooltip.defaultProps = {
  arrow: true, // tippy default
  hideOnClick: false, // tippy default
  showOnCreate: false,
  trigger: 'mouseenter focus', // tippy default
  visible: undefined,
  onClickOutside: undefined,
  animation: undefined,
  zIndex: 9999, // tippy default
};

export default Tooltip;
